(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 19752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ForwardRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgGraphicLines2 = function SvgGraphicLines2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 647,
    height: 674,
    viewBox: "0 0 647 674",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M633.133 -34.9798L471.773 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M574.4 -34.9798L413.04 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M515.666 -34.9798L354.293 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M456.92 -34.9798L295.56 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M398.186 -34.9798L236.826 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M339.453 -34.9798L178.093 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M280.707 -34.9798L119.347 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M221.973 -34.9798L60.6133 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M163.24 -34.9798L1.87988 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M588.36 227.097H562L620.32 -35.7656H646.68L588.36 227.097Z"
  })), _path11 || (_path11 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M529.614 227.097H503.254L561.587 -35.7656H587.947L529.614 227.097Z"
  })), _path12 || (_path12 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M470.88 227.097H444.521L502.84 -35.7656H529.2L470.88 227.097Z"
  })), _path13 || (_path13 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M412.147 227.097H385.787L444.107 -35.7656H470.467L412.147 227.097Z"
  })), _path14 || (_path14 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M353.4 227.097H327.04L385.373 -35.7656H411.733L353.4 227.097Z"
  })), _path15 || (_path15 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M294.667 227.097H268.307L326.64 -35.7656H353L294.667 227.097Z"
  })), _path16 || (_path16 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M235.934 227.097H209.574L267.894 -35.7656H294.254L235.934 227.097Z"
  })), _path17 || (_path17 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M177.201 227.097H150.841L209.161 -35.7656H235.521L177.201 227.097Z"
  })), _path18 || (_path18 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M118.454 227.097H92.0938L150.427 -35.7656H176.787L118.454 227.097Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(SvgGraphicLines2);

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,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");

/***/ }),

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(80327);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85814:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/imgCompanies.0974565e.png","height":1892,"width":3000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAALVBMVEWDhYdNSUIjLSpfYV1DRkAvLylTV1N0bmqJi41xc3M5Pzt/fXt5enpaVU04Qj6osmKwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALElEQVQImQXBhwEAIAgEsXuKCpb9xzUhBqwJtPk62mDZFXknFj4y5dgrlxQfEQ0AwLQXxGcAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 96801:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/imgTalent.a3c8c6b4.png","height":1892,"width":3000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAKlBMVEVjX11qamlBPDdPTEotIRpIPDx0cnNQT1E4NS9NSEJuX1daRDlnVk9CMyw8sQh2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKklEQVQImQXBBwEAIAzAsO4fwL9dEkQSy7N0iRquuKobz+mxCNlDDcRNPg+NAL3WOrgmAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 80327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Landing": function() { return /* binding */ Landing; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/hooks/use-update-header.tsx
var use_update_header = __webpack_require__(41898);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/utils/constants.ts + 14 modules
var constants = __webpack_require__(68579);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/hooks/use-clean-header.tsx
var use_clean_header = __webpack_require__(90573);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/seo/index.tsx
var seo = __webpack_require__(25352);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/assets/icons/graphic-lines.svg
var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgGraphicLines = function SvgGraphicLines(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 1180,
    height: 674,
    viewBox: "0 0 1180 674",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#clip0_5579_16003)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M663.254 -34.9798L501.894 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/react.createElement("path", {
    d: "M604.52 -34.9798L443.16 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/react.createElement("path", {
    d: "M545.786 -34.9798L384.413 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/react.createElement("path", {
    d: "M487.04 -34.9798L325.68 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/react.createElement("path", {
    d: "M428.306 -34.9798L266.946 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/react.createElement("path", {
    d: "M369.573 -34.9798L208.213 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/react.createElement("path", {
    d: "M310.827 -34.9798L149.467 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/react.createElement("path", {
    d: "M252.093 -34.9798L90.7334 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/react.createElement("path", {
    d: "M193.36 -34.9798L32 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/react.createElement("path", {
    d: "M618.48 227.097H592.12L650.44 -35.7656H676.8L618.48 227.097Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M559.734 227.097H533.374L591.707 -35.7656H618.067L559.734 227.097Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M501.001 227.097H474.641L532.961 -35.7656H559.321L501.001 227.097Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M442.267 227.097H415.907L474.227 -35.7656H500.587L442.267 227.097Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M383.52 227.097H357.16L415.493 -35.7656H441.853L383.52 227.097Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M324.787 227.097H298.427L356.76 -35.7656H383.12L324.787 227.097Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M266.054 227.097H239.694L298.014 -35.7656H324.374L266.054 227.097Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M207.321 227.097H180.961L239.281 -35.7656H265.641L207.321 227.097Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M148.574 227.097H122.214L180.547 -35.7656H206.907L148.574 227.097Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M1130.31 227.096L968.945 954.31",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/react.createElement("path", {
    d: "M1071.57 227.096L910.212 954.31",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/react.createElement("path", {
    d: "M1012.84 227.096L851.479 954.31",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/react.createElement("path", {
    d: "M954.105 227.096L792.731 954.31",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/react.createElement("path", {
    d: "M895.358 227.096L733.998 954.31",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/react.createElement("path", {
    d: "M836.625 227.096L675.265 954.31",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/react.createElement("path", {
    d: "M777.892 227.096L616.519 954.31",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/react.createElement("path", {
    d: "M719.145 227.096L557.785 954.31",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/react.createElement("path", {
    d: "M660.412 227.096L499.052 954.31",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/react.createElement("path", {
    d: "M1089.03 485.948H1062.67L1120.99 223.086H1147.35L1089.03 485.948Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M1030.28 485.948H1003.92L1062.25 223.086H1088.61L1030.28 485.948Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M971.546 485.948H945.186L1003.52 223.086H1029.88L971.546 485.948Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M912.812 485.948H886.452L944.772 223.086H971.132L912.812 485.948Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M854.079 485.948H827.719L886.039 223.086H912.399L854.079 485.948Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M795.333 485.948H768.973L827.306 223.086H853.666L795.333 485.948Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M736.599 485.948H710.239L768.559 223.086H794.919L736.599 485.948Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M677.866 485.948H651.506L709.826 223.086H736.186L677.866 485.948Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M619.119 485.948H592.772L651.092 223.086H677.452L619.119 485.948Z"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "clip0_5579_16003"
  }, /*#__PURE__*/react.createElement("rect", {
    width: 1180,
    height: 674,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgGraphicLines);

/* harmony default export */ var graphic_lines = ("data:image/svg+xml;base64,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");
// EXTERNAL MODULE: ../../libs/website-components/src/lib/assets/icons/graphic-lines-2.svg
var graphic_lines_2 = __webpack_require__(19752);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(10912);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/assets/backgrounds/imgTalent.png
var imgTalent = __webpack_require__(96801);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/assets/backgrounds/imgCompanies.png
var imgCompanies = __webpack_require__(85814);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/home-page/animated-main-section/index.module.scss
var index_module = __webpack_require__(5395);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/home-page/animated-main-section/index.tsx









const ANIMATIONS = {
    TALENT: "TALENT",
    COMPANY: "COMPANY"
};
const HomeAnimatedSection = /*#__PURE__*/ (0,react.forwardRef)((_, ref)=>{
    const [currentAnimation, setCurrentAnimation] = (0,react.useState)(undefined);
    const onTalentAnimation = (0,react.useCallback)(()=>{
        setCurrentAnimation(ANIMATIONS.TALENT);
    }, []);
    const onCompanyAnimation = (0,react.useCallback)(()=>{
        setCurrentAnimation(ANIMATIONS.COMPANY);
    }, []);
    const onRemoveAnimation = (0,react.useCallback)(()=>{
        setCurrentAnimation(undefined);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()((index_module_default())["section-container"], {
            [(index_module_default())["talent-background"]]: currentAnimation === ANIMATIONS.TALENT,
            [(index_module_default())["company-background"]]: currentAnimation === ANIMATIONS.COMPANY
        }),
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: imgTalent/* default */.Z,
                className: classnames_default()((index_module_default())["background-image"], (index_module_default())["talent-background-image"], {
                    [(index_module_default())["image-visible"]]: currentAnimation === ANIMATIONS.TALENT
                }),
                alt: "Person smiling while working with a team in a desk with personal computers",
                fill: true,
                sizes: "100vw"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: imgCompanies/* default */.Z,
                className: classnames_default()((index_module_default())["background-image"], {
                    [(index_module_default())["image-visible"]]: currentAnimation === ANIMATIONS.COMPANY
                }),
                alt: "Person smiling while closing a deal by handshaking another person",
                fill: true,
                sizes: "100vw"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (index_module_default()).title,
                        children: "Let's get there"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (index_module_default()).description,
                        children: "Engaging tech talent for trustworthy companies."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                        href: "/for-talent",
                        className: classnames_default()((index_module_default())["talent-button"], (index_module_default()).button),
                        onMouseEnter: onTalentAnimation,
                        onFocus: onTalentAnimation,
                        onMouseLeave: onRemoveAnimation,
                        onBlur: onRemoveAnimation,
                        variant: currentAnimation === ANIMATIONS.COMPANY ? "opacity" : "highlight",
                        prefetch: false,
                        children: "for talent"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                        href: "/for-companies",
                        onMouseEnter: onCompanyAnimation,
                        onFocus: onCompanyAnimation,
                        onMouseLeave: onRemoveAnimation,
                        onBlur: onRemoveAnimation,
                        variant: currentAnimation === ANIMATIONS.TALENT ? "opacity" : "highlight",
                        className: (index_module_default()).button,
                        prefetch: false,
                        children: "for companies"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                        href: "/for-talent",
                        className: classnames_default()((index_module_default())["talent-button"], (index_module_default())["mobile-button"]),
                        variant: "highlight",
                        size: "medium",
                        prefetch: false,
                        children: "for talent"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                        href: "/for-companies",
                        variant: "highlight",
                        className: (index_module_default())["mobile-button"],
                        size: "medium",
                        prefetch: false,
                        children: "for companies"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default())["background-lines-container"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardRef, {
                        className: classnames_default()((index_module_default()).icon, (index_module_default())["background-lines-left"])
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(graphic_lines_2/* ReactComponent */.r, {
                        className: classnames_default()((index_module_default()).icon, (index_module_default())["background-lines-right"])
                    })
                ]
            })
        ]
    });
});

// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/home-page/brands/index.module.scss
var brands_index_module = __webpack_require__(13126);
var brands_index_module_default = /*#__PURE__*/__webpack_require__.n(brands_index_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/home-page/brands/index.tsx





const BRANDS_LIST = [
    constants/* BRANDS_INFO.loadsmart */.r.loadsmart,
    constants/* BRANDS_INFO.benepass */.r.benepass,
    constants/* BRANDS_INFO.hapana */.r.hapana,
    constants/* BRANDS_INFO.gbe */.r.gbe,
    constants/* BRANDS_INFO.scholarsOfFinance */.r.scholarsOfFinance,
    constants/* BRANDS_INFO.highnote */.r.highnote
];
const Brands = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()((brands_index_module_default())["section-wrapper"], className),
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (brands_index_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (brands_index_module_default()).label,
                    children: "Trusted by"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (brands_index_module_default())["brands-container"],
                    children: BRANDS_LIST.map((brand)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: brand.href,
                            className: (brands_index_module_default()).link,
                            "aria-label": "Access ".concat(brand.id, " homepage"),
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(brand.icon, {
                                className: (brands_index_module_default())["brand-icon"]
                            }, brand.id)
                        }))
                })
            ]
        })
    });
});
/* harmony default export */ var brands = ((/* unused pure expression or super */ null && (Brands)));

// EXTERNAL MODULE: ../../libs/website-components/src/lib/layouts/website-layout/index.tsx + 9 modules
var website_layout = __webpack_require__(46087);
// EXTERNAL MODULE: ./pages/index.module.scss
var pages_index_module = __webpack_require__(23862);
var pages_index_module_default = /*#__PURE__*/__webpack_require__.n(pages_index_module);
;// CONCATENATED MODULE: ./pages/index.tsx




const SEO = {
    title: "Olby // Engaging tech talent for trustworthy companies",
    description: "Olby reduces intercultural barriers and promotes thriving work relationships. We foster connections between Brazilian talent and international companies, boosting global tech careers."
};
const Landing = ()=>{
    const homeAnimationRef = (0,react.useRef)(null);
    const brandsRef = (0,react.useRef)(null);
    (0,use_update_header/* useUpdateHeader */.G)(homeAnimationRef, constants/* HEADER_THEMES.BLURRED */._.BLURRED);
    (0,use_update_header/* useUpdateHeader */.G)(brandsRef, constants/* HEADER_THEMES.EXT_DEEP_BLUE */._.EXT_DEEP_BLUE);
    (0,use_clean_header/* useCleanHeader */._)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (pages_index_module_default()).main,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* WebsiteSeo */.P, {
                seo: SEO
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeAnimatedSection, {
                ref: homeAnimationRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Brands, {
                className: (pages_index_module_default())["brands-section"],
                ref: brandsRef
            })
        ]
    });
};
/* harmony default export */ var pages = (Landing);
Landing.getLayout = (page)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(website_layout/* WebsiteLayout */.CG, {
        shouldChangeBgColor: true,
        headerInitialTheme: constants/* HEADER_THEMES.BLURRED */._.BLURRED,
        children: page
    });
};


/***/ }),

/***/ 10912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ CTAButton; },
  "Z": function() { return /* binding */ components_button; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utils/src/hooks/use-event-tracking.tsx + 4 modules
var use_event_tracking = __webpack_require__(43287);
// EXTERNAL MODULE: ../../libs/utils/src/lib/amplitude/index.tsx
var amplitude = __webpack_require__(67071);
// EXTERNAL MODULE: ../../libs/utils/src/lib/helpers.ts
var helpers = __webpack_require__(44386);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/assets/icons/cta-arrow.svg
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgCtaArrow = function SvgCtaArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M8.16327 15.5L6.35957 13.7887L11.0943 9.25744H0V6.74256H11.0943L6.35957 2.21875L8.16327 0.5L16 8L8.16327 15.5Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgCtaArrow);

/* harmony default export */ var cta_arrow = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMTYzMjcgMTUuNUw2LjM1OTU3IDEzLjc4ODdMMTEuMDk0MyA5LjI1NzQ0SDBWNi43NDI1NkgxMS4wOTQzTDYuMzU5NTcgMi4yMTg3NUw4LjE2MzI3IDAuNUwxNiA4TDguMTYzMjcgMTUuNVoiLz4KPC9zdmc+Cg==");
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/button/index.module.scss
var index_module = __webpack_require__(8579);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/button/index.tsx







const CTAButton = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { className ="" , href , variant ="highlight" , size ="large" , children , trackingIdentifier , prefetch , isExternal =false , ...rest } = param;
    const classes = classnames_default()((index_module_default()).link, (index_module_default())[variant], (index_module_default())[size], className);
    const innerRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, ()=>innerRef.current);
    (0,use_event_tracking/* useClickEventTracking */.M)(innerRef, amplitude/* AmplitudeContext */.Lq, "website_button_click", {
        id: trackingIdentifier
    });
    const formattedUrl = isExternal ? href : (0,helpers/* formatUrl */.CN)(href);
    const renderChildren = (0,react.useMemo)(()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: (index_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (index_module_default())["arrow-wrapper"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardRef, {
                        className: (index_module_default()).icon
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (index_module_default())["button-label"],
                    children: children
                })
            ]
        });
    }, [
        children
    ]);
    if ((0,helpers/* isExternalUrl */.xf)(href) || isExternal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: formattedUrl,
            className: classes,
            ref: innerRef,
            ...rest,
            children: renderChildren
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: formattedUrl,
        prefetch: prefetch,
        className: classes,
        ref: innerRef,
        ...rest,
        children: renderChildren
    });
});
/* harmony default export */ var components_button = (CTAButton);


/***/ }),

/***/ 25352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ WebsiteSeo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55351);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



const WebsiteSeo = (param)=>{
    let { seo  } = param;
    const websiteUrl = "https://olby.com";
    const { asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const asPathWithoutParams = asPath.split("?")[0];
    const canonical = websiteUrl + asPathWithoutParams;
    const websiteSeo = {
        canonical,
        ...seo
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        ...websiteSeo
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WebsiteSeo);


/***/ }),

/***/ 23862:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main___rT19","brands-section":"index_brands-section__JeYPp","fade-in-up":"index_fade-in-up__LzcmM","fade-in-opacity":"index_fade-in-opacity__d_UVE","fade-in-up-opacity":"index_fade-in-up-opacity__1928X","fade-out-opacity":"index_fade-out-opacity__qByI9","fade-out-left":"index_fade-out-left__5VToX"};

/***/ }),

/***/ 8579:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"button_link__VCdDw","content":"button_content__ww7LJ","arrow-wrapper":"button_arrow-wrapper__D7KzQ","button-label":"button_button-label__2vBy5","large":"button_large__QhZHB","icon":"button_icon__ix2fV","medium":"button_medium__69Qyj","highlight":"button_highlight__5uvSX","theme--light":"button_theme--light__A2fZm","theme--dark":"button_theme--dark__NiIj7","primary":"button_primary__r9bak","secondary":"button_secondary__nR_xE","white":"button_white__Ln1lX","opacity":"button_opacity__zewbz","fade-in-up":"button_fade-in-up__4Yakx","fade-in-opacity":"button_fade-in-opacity__uiUG0","fade-in-up-opacity":"button_fade-in-up-opacity__CjxjG","fade-out-opacity":"button_fade-out-opacity__U5xnx","fade-out-left":"button_fade-out-left__QoJqj"};

/***/ }),

/***/ 5395:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section-container":"animated-main-section_section-container__24_pc","theme--light":"animated-main-section_theme--light__Qh2J0","theme--dark":"animated-main-section_theme--dark__0XLCD","background-image":"animated-main-section_background-image__6BrqZ","talent-background-image":"animated-main-section_talent-background-image__QZuXq","image-visible":"animated-main-section_image-visible__5WchD","talent-background":"animated-main-section_talent-background__7jSQf","background-lines-container":"animated-main-section_background-lines-container___Gzs5","icon":"animated-main-section_icon__jNeNw","company-background":"animated-main-section_company-background__gMdsk","content":"animated-main-section_content__BdeXa","title":"animated-main-section_title__tgPpd","description":"animated-main-section_description__8Knfu","talent-button":"animated-main-section_talent-button__hOk1v","button":"animated-main-section_button___R4QV","mobile-button":"animated-main-section_mobile-button__YJ8Xj","background-lines-left":"animated-main-section_background-lines-left__ZbBvv","background-lines-right":"animated-main-section_background-lines-right__RwcBT","fade-in-up":"animated-main-section_fade-in-up__dvK9N","fade-in-opacity":"animated-main-section_fade-in-opacity__PnsQS","fade-in-up-opacity":"animated-main-section_fade-in-up-opacity__hi3M5","fade-out-opacity":"animated-main-section_fade-out-opacity__u6PHi","fade-out-left":"animated-main-section_fade-out-left__gAEj_"};

/***/ }),

/***/ 13126:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section-wrapper":"brands_section-wrapper__olJ7H","theme--light":"brands_theme--light__ZJo0B","theme--dark":"brands_theme--dark__15TX_","content":"brands_content__bJaTx","label":"brands_label__tYXzA","brands-container":"brands_brands-container__l8PPo","brand-icon":"brands_brand-icon__e_x_9","link":"brands_link__8bMxR","fade-in-up":"brands_fade-in-up__HFVfq","fade-in-opacity":"brands_fade-in-opacity__kUmpi","fade-in-up-opacity":"brands_fade-in-up-opacity__u4RPP","fade-out-opacity":"brands_fade-out-opacity__sPk6S","fade-out-left":"brands_fade-out-left__IaUE1"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [350,82,577,559,774,888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);